<template>
  <div class="official-coach-bond">
    <div class="off-event-box">
      <img src="../../assets/images/smart_venues_bg.png">
    </div>
    <div class="off-footer-box display-flex-end">
      <div v-if="false" class="off-btn-item green"><div>联系顾问</div></div>
      <div class="off-btn-item yellow" @click="goTrial"><div>我想试用</div></div>
    </div>
  </div>
</template>

<script>
import { getAppPath, varConfig, ImageFormat } from '@/utils'

export default {
  name: 'officialSmartVenues',
  data() {
    return {
    }
  },
  created() {

  },
  mounted() {
    this.shareData = {
      title: '智慧场馆·轻量级场馆管理专家',
      link: this.getShareLink(),
      image: ImageFormat.squareImageView('FiyWzstnQ98KV_cqnYgPkCljISPc', 120)
    }
    this.wxShare(this.shareData)
  },
  methods: {
    goTrial() {
      const path = getAppPath('webapplt')
      const url = `${varConfig.siteUrl}/${path}/index/index.html#/reservation?type=3&result=场馆系统`
      window.location.href = url
    },
    getShareLink: function () {
      const arr = window.location.href.split('index.html')
      return arr[0] + 'index.html#/official-smartVenues?v=1'
    }
  }
}
</script>

<style lang="scss">
  .official-coach-bond {
    .off-event-box{
      width: 100%;
      position: relative;
      padding-bottom: 51px;
      img{
        width: 100%;
        height: 100%;
        position: relative;
        top: 0;
        left: 0;
      }
    }
    .off-footer-box{
      position: fixed;
      bottom: 0;
      width: 100%;
      max-width: 480px;
      height: 50px;
      background: rgba(255, 255, 255, 0.8);
      padding: 4px 0;
      .off-btn-item{
        display: inline-block;
        padding: 4px 17px;
        border-radius: 24px;
        color: #FFFFFF;
        cursor: pointer;
      }
      .green{
        background: linear-gradient(180deg, #76A563 0%, #547C54 100%);
        margin-right: 15px;
      }
      .yellow{
        background: linear-gradient(180deg, #F9AF0E 0%, #B67016 100%);
        margin-right: 38px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/official-smartVenues/index.vue